import { useEffect, RefObject } from "react";

type Events = MouseEvent | TouchEvent;

export interface UseClickOutsideOptions {
  ref: RefObject<HTMLElement>;
  onOutsideClick: (event: Events) => void;
}

export default function useClickOutside({
  ref,
  onOutsideClick,
}: UseClickOutsideOptions) {
  useEffect(() => {
    function handleClick(event: Events) {
      if (
        !ref.current ||
        (event.target instanceof HTMLElement &&
          ref.current.contains(event.target))
      ) {
        return;
      }

      onOutsideClick(event);
    }

    document.addEventListener("mousedown", handleClick);
    document.addEventListener("touchstart", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("touchstart", handleClick);
    };
  }, [ref, onOutsideClick]);
}
